<template>
  <div>
    <!-- MODO TELA NORMAL -->
    <div v-if="!printMode">
      <h6>Provas x Escola</h6>
      <p></p>

      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input type="date" v-model="dataInicioLocal" class="form-control" />
        </div>

        <div class="col-auto">
          <label>Data Fim:</label>
          <input type="date" v-model="dataFimLocal" class="form-control" />
        </div>

        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- MODO IMPRESSÃO -->
    <div v-else>
      <h6 class="text-center mb-3" style="font-size: 14px;">
        {{ props.subtitle }}
      </h6>

      <div v-if="loading">Carregando…</div>

      <div v-else>
        <div v-if="registros.length">
          <h6>Receitas de Campeonatos Internos</h6>

          <table class="table table-striped mb-4">
            <thead>
              <tr>
                <th>#</th>
                <th>Lançamento</th>
                <th>Observação</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in registros" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ globalUtils.formatarData(item.lancamento) }}</td>
                <td>{{ item.observacao }}</td>
                <td class="text-right">{{ formatarMoeda(item.valor) }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="3"><strong>Total</strong></td>
                <td class="text-right">
                  <strong>{{ formatarMoeda(total) }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-else>
          <p class="text-muted">
            Nenhuma receita de campeonatos internos encontrada para este período.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Relatório' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

const dataInicioLocal = ref('')
const dataFimLocal = ref('')

const loading = ref(false)
const registros = ref([])
const total = ref(0)

onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true

  try {
    const res = await axios.get('/gestao/relatorios/financeiros/provas-escola', {
      params: {
        dataInicio: props.dataInicio,
        dataFim: props.dataFim
      }
    })

    registros.value = Array.isArray(res.data.registros) ? res.data.registros : []
    total.value = parseFloat(res.data.total) || 0
  } catch (e) {
    console.error('Erro ao buscar relatório Provas x Escola:', e)
    registros.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
})

function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado = globalUtils.formatarData(dataFimLocal.value)

  const subtitle = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: '/gestao/relatorios/print/provas-escola',
    query: {
      title: 'Provas x Escola',
      dataInicio: dataInicioLocal.value,
      dataFim: dataFimLocal.value,
      subtitle
    }
  })
}

function formatarMoeda(num) {
  if (num == null) return ''

  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}

.text-right {
  text-align: right !important;
}
</style>